export default {
    name: 'v5-icon-heart',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M523.733 841.024l33.174-32.576 99.69-97.813c70.976-69.632 120.32-117.974 138.71-135.894 59.008-57.514 93.248-121.28 99.626-184.234 6.251-61.44-15.488-119.744-61.589-164.672-44.992-43.84-98.88-61.91-157.035-52.907-49.365 7.616-101.034 34.624-150.016 78.848a21.333 21.333 0 01-28.586 0c-48.982-44.224-100.651-71.232-150.016-78.87-58.155-8.96-112.043 9.089-157.035 52.929-46.101 44.928-67.84 103.21-61.61 164.693 6.4 62.933 40.64 126.72 99.647 184.213a100207.573 100207.573 0 01145.92 142.827l24.256 23.765L512 852.523l11.733-11.499zM512 852.544l-1.493 1.43a2.133 2.133 0 011.493-.64c.512 0 1.045.213 1.493.64L512 852.522zm157.781-721.792c71.638-11.093 138.902 11.477 193.344 64.533 55.318 53.931 81.835 124.992 74.283 199.531-7.467 73.643-46.55 146.368-112.32 210.475-18.347 17.898-67.67 66.218-138.453 135.637-31.83 31.232-65.707 64.448-99.84 97.984L553.6 871.467l-13.184 12.949a40.555 40.555 0 01-56.832 0l-114.603-112.64-24.213-23.723a677626.347 677626.347 0 00-145.856-142.762C133.142 541.184 94.08 468.48 86.613 394.816c-7.552-74.539 18.944-145.6 74.283-199.53 54.443-53.057 121.707-75.606 193.344-64.534 53.163 8.213 107.093 34.688 157.781 76.95 50.71-42.24 104.619-68.737 157.782-76.95z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
